// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_fMS","footer":"styles_footer__TF4dT"};